import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getDashboard, getFlights } from "../lib/api";
import LiveMap from "../components/LiveMap";

const OperationsMap = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const focus = params.get("focus");
  const label = params.get("label") || "";
  const focusCoord = focus ? focus.split(",").map(Number) : null;

  const { data: dashboard } = useQuery({ queryKey: ["dashboard"], queryFn: getDashboard, refetchInterval: 20000 });
  const { data: flights } = useQuery({ queryKey: ["flights"], queryFn: getFlights, refetchInterval: 60000 });

  return (
    <div className="ops-page" data-testid="operations-map-page">
      {!dashboard ? (
        <div className="loading-screen"><div className="loader"><div className="spin" /><p>Loading Operations Map…</p></div></div>
      ) : (
        <LiveMap
          fullscreen
          onBack={() => navigate("/")}
          focusCoord={focusCoord}
          focusLabel={label}
          routes={dashboard.routes}
          aircraft={flights?.airspace?.aircraft || []}
          overlays={dashboard.map_overlays}
        />
      )}
    </div>
  );
};

export default OperationsMap;
